import React from "react";
import styled from "styled-components";
import { Box, Link, Stack } from "@mui/material";
import HistoryToggleOffIcon from "@mui/icons-material/HistoryToggleOff";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import TimeSplitter from "src/utils/time-splitter";
import CustomTooltip from "src/components/custom-tooltip";

const BodyText = styled.p`
    font-size: 12px;
    margin: 0;
    color: ${({ theme, type }) => {
        if (type === "Bug") return theme.palette.background.bugs;
        if (type === "Feature") return theme.palette.background.features;
        if (type === "Task") return theme.palette.background.tasks;
        return theme.palette.secondary.main;
    }};
`;

const MissionContainer = styled(Stack)`
    border: 1px solid #585858;
    border-radius: 6px;
    padding: 8px;
    white-space: nowrap;
    max-width: 256px;
    min-width: 256px;
`;

const TitleLink = styled(Link)`
    font-size: 12px;
    font-weight: 400;
    margin-bottom: 0px;
    color: #ffffff;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const DescriptionText = styled.p`
    font-size: 12px;
    font-weight: 300;
    color: #ffffff;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const StatusChip = styled.p`
    padding: 2px 5px;
    font-size: 10px;
    background-color: #303030;
    border-radius: 24px;
`;

const EstimatedActualTime = ({ data, filterEstimatesBy }) => {
    const filteredData =
        data &&
        data.tickets &&
        data.tickets.filter((item) => {
            if (filterEstimatesBy === "done") {
                return item.status === "Done";
            }
            if (filterEstimatesBy === "in-progress") {
                return item.status === "In Progress";
            }
            if (filterEstimatesBy === "to-do") {
                return item.status === "To Do";
            }
            return true;
        });

    return (
        <Box
            style={{
                overflow: "auto",
                height: !data || (data && data.tickets && !data.tickets.length) ? 0 : "9.5rem",
            }}
        >
            <Stack
                direction="row"
                spacing={1}
                pr={2}
                style={{ width: "98%", marginTop: "12px", overflowX: "auto" }}
            >
                {filteredData &&
                    filteredData.map((item) => {
                        return (
                            <MissionContainer
                                direction="column"
                                style={{ marginBottom: "12px", width: "280px" }}
                            >
                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    style={{ width: "100%" }}
                                >
                                    <Stack direction="row" spacing={0.5} alignItems="center">
                                        <TitleLink
                                            underline="hover"
                                            href={item.issueUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {item.issueKey}
                                        </TitleLink>
                                        <StatusChip>{item.status}</StatusChip>
                                    </Stack>
                                    <Stack direction="row" spacing={1}>
                                        <BodyText type={item.type}>{item.type}</BodyText>
                                    </Stack>
                                </Stack>
                                <CustomTooltip title={item.summary}>
                                    <DescriptionText>{item.summary}</DescriptionText>
                                </CustomTooltip>

                                <Stack
                                    direction="row"
                                    justifyContent="space-between"
                                    style={{ width: "100%" }}
                                >
                                    <Stack direction="row" alignItems="center" spacing={0.5}>
                                        <HistoryToggleOffIcon fontSize="small" />
                                        <BodyText>
                                            {item.timeEstimated === null || item.timeEstimated === 0
                                                ? "No time"
                                                : TimeSplitter(item.timeEstimated, "tickets")}
                                        </BodyText>
                                    </Stack>
                                    <Stack direction="row" alignItems="center" spacing={0.5}>
                                        <QueryBuilderIcon fontSize="small" />
                                        <BodyText>
                                            {item.timeSpent === null || item.timeSpent === 0
                                                ? "No time"
                                                : TimeSplitter(item.timeSpent, "tickets")}
                                        </BodyText>
                                    </Stack>
                                </Stack>
                            </MissionContainer>
                        );
                    })}
            </Stack>
        </Box>
    );
};

export default EstimatedActualTime;
